import { apiWithTag } from "../emptySplitApi";
import { ApiDocumentEmailPagable, ApiDocuments, ApiFieldAnswer, ApiRiskAssessmentFields, ApiRiskScoringFields, ApiUpdateRiskScoringAnswers, DocumentEmailRequest, PagedDocumentEmailRequest } from ".";


export const risksApi = apiWithTag.injectEndpoints({
    endpoints: (builder) => ({
        riskAssessmentFields: builder.query<ApiRiskAssessmentFields, { duediligenceId: string }>({
            query: ({ duediligenceId }) => ({
                method: 'GET',
                url: `v1/due-diligence/${duediligenceId}/risk-assessment`,
                subDomain: 'verification',
            }),
            providesTags: ['Risk']
        }),
        updateRiskAssessment: builder.mutation<ApiRiskAssessmentFields, { duediligenceId: string, body: ApiRiskAssessmentFields }>({
            query: ({ duediligenceId, body }) => ({
                method: 'PUT',
                url: `v1/due-diligence/${duediligenceId}/risk-assessment`,
                subDomain: 'verification',
                body: { ...body }
            }),
            invalidatesTags: ['Risk']
        }),

        riskScoringFields: builder.query<ApiRiskScoringFields, { duediligenceId: string }>({
            query: ({ duediligenceId }) => ({
                method: 'GET',
                url: `v1/due-diligence/${duediligenceId}/risk-scoring`,
                subDomain: 'verification',

            }),
            providesTags: ['Risk']
        }),

        riskScoringFieldAnswerValues: builder.query<ApiFieldAnswer[], { answerType: string }>({
            query: ({ answerType }) => ({
                method: 'GET',
                url: `v1/due-diligence/risk-scoring/fields/${answerType}`,
                subDomain: 'verification',


            }),
            providesTags: ['Risk']
        }),


        updateRiskScoring: builder.mutation<ApiRiskAssessmentFields, { duediligenceId: string, body: ApiUpdateRiskScoringAnswers }>({
            query: ({ duediligenceId, body }) => ({
                method: 'PUT',
                url: `v1/due-diligence/${duediligenceId}/risk-scoring`,
                subDomain: 'verification',
                body: { ...body }
            }),
            invalidatesTags: ['Risk']
        }),

        documentsHistory: builder.query<ApiDocuments, { latest?: boolean }>({
            query: ({ latest = false }) => ({
                method: 'GET',
                url: `v2/kyc/documents/history${latest ? '?latest=true' : ''}`,
                subDomain: 'verification',

            }),
            providesTags: ['Risk']
        }),
        // documentsEmailLatest: builder.query<void, { recipientEmailAddress: string }>({
        //     query: ({ recipientEmailAddress }) => ({
        //         method: 'GET',
        //         url: `v2/kyc/documents/email/latest/${recipientEmailAddress}`

        //     }),
        //     providesTags: ['Risk']
        // }),
        documentsEmail: builder.mutation<void, DocumentEmailRequest>({
            query: ({ recipientEmailAddress, recipientName, ...body }) => ({
                method: 'POST',
                url: `v2/kyc/documents/email?recipientEmailAddress=${recipientEmailAddress}${recipientName !== undefined ? '&recipientName=' + recipientName : ''}`,
                subDomain: 'verification',
                body: { ...body }

            }),
        }),
        kycDocumentsEmails: builder.query<ApiDocumentEmailPagable, PagedDocumentEmailRequest>({
            query: (request) => ({
                method: 'GET',
                url: `v2/kyc/documents/email`,
                params: request,
                subDomain: 'verification',
            }),
            providesTags: ['Risk']
        }),
    })
})

export const {
    useRiskAssessmentFieldsQuery,
    useUpdateRiskAssessmentMutation,

    useRiskScoringFieldsQuery,
    useRiskScoringFieldAnswerValuesQuery,

    useUpdateRiskScoringMutation,

    useDocumentsHistoryQuery,
    // useLazyDocumentsEmailLatestQuery,
    useDocumentsEmailMutation,
    useKycDocumentsEmailsQuery,
} = risksApi;